<template>
	<div class="box-comment">
		<Notification ref="notif" :closed="true" corner="bottom-right" style="color:#061529;"/>
		<span class="title">COMENTÁRIO </span>
		<hr>
		<div class="desc"><textarea :disabled="!disabled" type="text" v-model="colecao.comentario" placeholder="Digite aqui algum comentário geral para o desenvolvimento do conteúdo."/></div>
		<div class="btns" v-if="disabled">
			<button class="send" @click="save($route.query.id)">GRAVAR COMENTÁRIO</button>
		</div>
	</div>
</template>

<script>
import { colecoes } from '@/services/colecoes'
export default {
	name: 'Comentario',
	props: ['colecao', 'disabled'],
	data () {
		return {
			dados: {}
		}
	},
	methods: {
		async save (id) {
			this.dados.nome = this.colecao.nome
			this.dados.descricao = this.colecao.descricao
			this.dados.comentario = this.colecao.comentario
			this.dados.colecaoId = this.colecao.colecaoId

			const colecao = await colecoes.salvarComentario(id, this.dados)
			if (colecao.status === 200) {
				window.notificationEM.open('', 'Alteração realizada com sucesso!', 'success')
			} else {
				window.notificationEM.open('', 'Erro na alteração!', 'error')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	.box-comment {
		background-color: #061529;
		color:#fff;
		margin-top:50px;
		border-radius: 10px;
		padding: 30px 50px 15px 50px;

		.title {
			font-size: 24px;
			font-weight: 700;
			font-family: Roboto;
		}
		hr {
			border: solid 1px;
			border-color:#59708F;
		}
		.desc {
			margin-top:10px;
			border-radius: 10px;
			height: 100px;
			color:#fff;

			textarea {
				font-family: Roboto;
				background-color: #FFFFFF1A;
				border: none;
				border-radius: 5px;
				width: 100%;
				height: 100%;
				padding: 10px;
				font-size: 20px;
				color:#fff;
				resize: none;
			}
		}
		.btns {
			display: flex;
			justify-content: flex-end;
			color:#FFFFFF;
			font-family: Roboto;
			font-stretch: condensed;

			.send {
				background-color:#00659D;
				width: 200px;
				padding: 9px 0px 10px;
				border: none;
				color: #FFF;
				text-transform: uppercase;
				font-weight: 700;
				font-size: 16px;
				border-radius: 5px;
				font-family: Roboto;
				margin-top:20px;
				cursor: pointer;
			}
		}
	}
</style>
